<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <v-expansion-panels
      v-model="panel"
      class="app-expansion-panels"
    >
      <v-expansion-panel @click.stop="changeCollapse">
        <v-expansion-panel-header class="app-expansion-panel-header mb-0">
          <h4 class="text d-flex align-center">
            <v-icon left>filter_alt</v-icon>
            <span>Filtrar Lotes</span>
          </h4>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="app-expansion-panel-content">
          <v-row class="mt-3">
            <v-col cols="12" sm="6" md="3" lg="2" >
              <v-text-field
                v-model="tableLotes.paginate.numeroLote"
                :clearable="true"
                label="Número do Lote"
                placeholder="Digite o Número do Lote"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2" >
              <v-select
                v-model="tableLotes.paginate.entidadeId"
                :items="tableLotes.dadosFilterLotes.listEntidade"
                item-text="razaoSocial"
                item-value="id"
                :clearable="true"
                label="Entidade"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2" >
              <v-select
                v-model="tableLotes.paginate.situacao"
                :items="tableLotes.dadosFilterLotes.listSituacao"
                item-text="descricao"
                item-value="id"
                :clearable="true"
                label="Status do Lote"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <InputRangeDatePicker
                @startDate="(valor)=>onChangeData(valor, 'dataInicio')"
                @endDate="(valor)=>onChangeData(valor, 'dataFim')"
                :datesFormat="datesFormat"
              />
            </v-col>
          </v-row>
            <div class="mt-3 d-flex actions-row">
              <v-spacer />
              <v-btn
                outlined
                color="error"
                type="button"
                class="mr-2"
                @click.prevent.stop="clearFilter"
              >
                <v-icon size="14">delete</v-icon>
                Limpar Filtros
              </v-btn>
              <v-btn depressed color="primary" type="submit">
                Filtrar
              </v-btn>
            </div>
          <section
            v-if="tableLotes.isLoading"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </section>
          <div id="endForm" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import InputRangeDatePicker from "@/components/InputRangeDatePicker.vue";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import GraficaService from "@/services/sie-pedidos/grafica.service";

const actions = mapActions('siePedidos', ['setTableLotesContent', 'setTableLotesIsLoading', 'setTableLotesTotals', 'clearTableLotes', 'setDadosFilterGrafica'])
const state = mapState('siePedidos', ['tableLotes'])

export default {
  components: {
    InputRangeDatePicker
  },
  data: () => ({
    panel:false,
    datesFormat: null
  }),
  computed: {
    ...state
  },
  mounted() {
    GraficaService.getDadosFilterGrafica().subscribe(response=>{
      this.setDadosFilterGrafica(response.result)
    })
  },
  methods: {
    onChangeData(valor, item){
      const paginate = this.tableLotes.paginate
      this.tableLotes.paginate[item] = FunctionsCommuns.formatDate(valor)
      const dataFinal = paginate.dataFim ? `~ ${FunctionsCommuns.formatBRDate(paginate.dataFim)}` : ''
      this.datesFormat = paginate.dataInicio ? `${FunctionsCommuns.formatBRDate(paginate.dataInicio)} ${dataFinal}` : null;
    },
    async onSubmit() {
      await this.search();
      this.$vuetify.goTo("#endForm");
    },
    clearFilter() {
      this.datesFormat = null;
      this.clearTableLotes();
      this.search();
    },
    changeCollapse() {},
    search() {
      this.setTableLotesIsLoading(true)
      GraficaService.getListaLotes(this.tableLotes.paginate).subscribe(({result})=>{
        this.setTableLotesContent(result.data)
        this.setTableLotesTotals(result.totalElements)
        this.setTableLotesIsLoading(false)
      }, (error)=>{
        this.setTableIsLoading(false)
      })
    },
    ...actions
  },
};
</script>
<style scoped>
/* Ajusta espaçamento dos campos */
.app-expansion-panel-content .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Botões responsivos */
@media (max-width: 600px) {
  .actions-row {
    flex-direction: column;
    align-items: stretch !important;
  }

  .actions-row .v-btn {
    width: 100%;
    margin: 4px 0 !important;
  }
}
</style>